module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-consumable-item-shop-stock-count-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_consumable_item_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Consumable Item List')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/master_consumable_item/" + _vm.consumable_item_id + "/stock_count")
    }
  }, [_vm._v(_vm._s(_vm.$t('Shop Stock Consumable Item Count List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Shop Stock Consumable Item Count Edit')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Shop Stock Consumable Item Count Edit')))]), (_vm.searchEnd) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-right"
  }, [_vm._v(_vm._s(_vm.$t('shopConsumableItem.label.consumable_item_name')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItemCount.consumable_item_name))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-right"
  }, [_vm._v(_vm._s(_vm.$t('shopConsumableItem.label.shop_name')))]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_vm._v(_vm._s(_vm.consumableItemCount.shop_name))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-right"
  }, [_vm._v(_vm._s(_vm.$t('shopConsumableItem.label.just_stock_number')))]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumableItemCount.just_stock_number),
      expression: "consumableItemCount.just_stock_number"
    }],
    staticClass: "form-control text-right",
    class: {
      required: !_vm.validation.just_stock_number
    },
    attrs: {
      "type": "text",
      "placeholder": "数値を入力してください",
      "maxlength": "11"
    },
    domProps: {
      "value": _vm._s(_vm.consumableItemCount.just_stock_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumableItemCount.just_stock_number = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.just_stock_number),
      expression: "!validation.just_stock_number"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]), _c('div', {
    staticClass: "col-sm-2 margin-top",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.consumableItemCount.unit))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [(_vm.isStockCheckPeriod) ? _c('a', {
    staticClass: "btn btn-info",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]) : _c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validationAll
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77828fe7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-consumable-item-shop-stock-count-edit.pug
// module id = 882
// module chunks = 1